{
  "deselectedItem": "{Item} не выбрано.",
  "select": "Выбрать",
  "selectedAll": "Выбраны все элементы.",
  "selectedCount": "{count, plural, =0 {Нет выбранных элементов} one {# элемент выбран} other {# элементов выбрано}}.",
  "selectedItem": "{Item} выбрано."
}
